<template>
	<div>
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="true"
			staticMode="true"
		>
		</TopAppBar>
		<div class="d-flex flex-column">
			<TopAppBarDrawer></TopAppBarDrawer>
			<main class="main-wrapper flex-grow-1">
				<div class="d-flex align-items-center bg-white">
					<div class="t-headline11 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 ">
						{{ $t('1723') }}
					</div>
				</div>
				<div class="divider"></div>
				<div class="container container--narrow pdt-30">
					<div class="mdc-card pdt-8 pdb-8">
						<div class="d-flex leader-list pdt-16 pdb-16 pdr-24 pdl-24">
							<div class="pdt-4 mgr-16">
								<span class="lb-first-letter bg-iconInactive ">
									<i class="material-icons t-headline8">photo_camera</i>
									</span>
							</div>
							<div class="d-flex align-items-center justify-content-between flex-grow-1">
								<div class="flex-grow-1 pdr-16">
									<div class="t-body1 font-r l-spacing48 ">{{ $t('1724') }}</div>
									<div class="t-body2 font-r t-color-bodyGrayA mgt-6">
										{{ $t('1725') }}
									</div>
									<div class="t-body2 font-r t-color-bodyGrayA mgt-15">{{ $t('1725') }}</div>
								</div>
							</div>
						</div>
						<div class="d-flex leader-list pdt-16 pdb-16 pdr-24 pdl-24">
							<div class="pdt-4 mgr-16">
								<span class="lb-first-letter bg-iconInactive ">
									<i class="material-icons t-headline8">cloud_upload</i>
								</span>
							</div>
							<div class="d-flex align-items-center justify-content-between flex-grow-1">
								<div class="flex-grow-1 pdr-16">
									<div class="t-body1 font-r l-spacing48 ">{{ $t('1727') }}</div>
									<div class="t-body2 font-r t-color-bodyGrayA mgt-6">
										{{ $t('1728') }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mgt-8 t-color-bodyGrayA t-body4 font-r l-spacing39">
						{{ $t('1729') }}
					</div>
					<!-- <div class="mgt-50 mgb-50">
									<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8">
													<div class="mdc-button__ripple"></div>
													<span class="mdc-button__label t-body2 font-r">확인</span>
									</button>
					</div> -->
				</div>

			</main>
		</div>
	</div>
</template>

<style scoped>

</style>

<script>
import TopAppBar from '@/components/TopAppBar.vue'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import {topAppBarMixin} from '@/mixins/topAppBar.js'

export default {

	data() {
		return {
		title:localStorage.getItem('brandName')
		}
	},
	components: {
		TopAppBar,
		TopAppBarDrawer,
	},

	mixins: [topAppBarMixin],
}
</script>
